/**
 * Saison = 01.11. bis 31.10. Benannt wird sie nach dem Endjahr (Saison 2025 = 01.11.2024 - 31.10.2025),
 * der Wert ist das Startjahr (wie im Excel-Export-Modal).
 */
export function saisonOptions(yearsBack = 6) {
  const now = new Date();
  const current = now.getMonth() >= 10 ? now.getFullYear() : now.getFullYear() - 1;
  const options = [];
  for (let start = current + 1; start >= current - yearsBack; start--) {
    options.push({
      id: start,
      label: `Saison ${start + 1} (01.11.${start} – 31.10.${start + 1})`,
    });
  }
  return options;
}

export function saisonVon(startYear) {
  return startYear ? `${startYear}-11-01` : undefined;
}

export function saisonBis(startYear) {
  return startYear ? `${startYear + 1}-10-31` : undefined;
}
